/** Thin horizontal rule used to break a card's contents into sections.
 *
 * Wrap-only for now — kept as a component so future variants (spacing,
 * inline label, accent color) can be added without touching every call
 * site.
 */
export function Divider() {
  return <hr className="section-divider" />;
}
